module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-13-d349d716444c735a70008ba09ebfef42.png";